<template>
  <ul class="c-products-list">
    <li v-for="(link, id) in links" :key="id">
      <a :href="`/produkt/${ link.fields.title.text.toLowerCase() }`" :class="active == link.fields.title.text.toLowerCase() ? 'active': ''">
        <img :src="`${ link.fields.image.secure_url }`" alt="">
        <span>{{ link.fields.title.text }}</span>
      </a>
    </li>
  </ul>
</template>


<script>
export default {
  name: 'component-product-list',
  props: [ 'links', 'active' ],
}
</script>